import React, { lazy } from "react";
import Error404 from "../pages/errors/error404";
import { platforms, userRequestType } from "../constant";
// Las pantallas se cargan bajo demanda (code splitting) para reducir el bundle inicial

const Home = lazy(() => import("../components/dashboard/"));
const RoleManagement = lazy(() => import("../components/role/role"));
const CreateOrEditRole = lazy(() => import("../components/role/createOrEditRole/createOrEditRole"));
const UserEdit = lazy(() => import("../components/user/editProfile/editProfile"));
const UserManagement = lazy(() => import("../components/user/user"));
const CreateOrEditUser = lazy(() => import("../components/user/createOrEditUser/createOrEditUser"));
const RouteManagement = lazy(() => import("../components/route/route"));
const ServiceManagement = lazy(() => import("../components/service/service"));
const CreateOrEditAmbulance = lazy(() => import("../components/ambulance/createOrEditAmbulance/createOrEditAmbulance"));
const RouteDetails = lazy(() => import("../components/route/routeDetails/routeDetails"));
const CreateOrEditService = lazy(() => import("../components/service/createOrEditService/createOrEditService"));
const AmbulanceManagement = lazy(() => import("../components/ambulance/ambulance"));
const UserRequestManagement = lazy(() => import("../components/userRequest/userRequest"));
const UserRequestDetails = lazy(() => import("../components/userRequest/userRequestDetails/userRequestDetails"));
const RoleDetails = lazy(() => import("../components/role/details/roleDetails"));
const TrackingMap = lazy(() => import("../components/utils/trackingMap/trackingMap"));
const IncidentManagement = lazy(() => import("../components/incident/incident"));
const IncidentDetails = lazy(() => import("../components/incident/incidentDetails/incidentDetails"));
const Map = lazy(() => import("../components/map/map"));
const AreaManagement = lazy(() => import("../components/area/area"));
const CreateOrEditArea = lazy(() => import("../components/area/createOrEditArea/createOrEditArea"));
const AmbulanceReportManagement = lazy(() => import("../components/report/ambulance-report/ambulance-report"));
const UserRequestReportManagement = lazy(() => import("../components/report/user-request-report/user-request-report"));
const AppVersioningManagement = lazy(() => import("../components/appVersioning/appVersioning"));
const CreateOrEditAppVersion = lazy(() => import("../components/appVersioning/createOrEditAppVersion/createOrEditAppVersion"));
const AdvertisingManagement = lazy(() => import("../components/advertising/advertising"));
const CreateOrEditAdvertising = lazy(() => import("../components/advertising/createOrEditAdvertising/createOrEditAdvertising"));

// Rutas para la gestión de solicitudes y de reservaciones
const userRequestRoutes = userRequestType.flatMap((type) => [
  {
    path: `/user-request-management/${type}`,
    element: <UserRequestManagement key={type} type={type} />,
  },
  {
    path: `/user-request-management/${type}/:id`,
    element: <UserRequestDetails key={type} type={type} />,
  },
]);

// Rutas para la gestión de usuarios
const userRoutes = platforms.flatMap((platform) => [
  {
    path: `/users-management/${platform}/`,
    element: <UserManagement key={platform} platform={platform} />,
  },
  {
    path: `/users-management/${platform}/:id`,
    element: <CreateOrEditUser key={platform} platform={platform} />,
  },
  {
    path: `/users-management/${platform}/create-user`,
    element: <CreateOrEditUser key={platform} platform={platform} />,
  },
]);

export const routes = [
  {
    path: "/dashboard",
    element: <Home />,
  },
  {
    path: "/error404",
    element: <Error404 />,
  },
  {
    path: "/ambulance-management",
    element: <AmbulanceManagement />,
  },
  {
    path: "/ambulance-management/:id",
    element: <CreateOrEditAmbulance />,
  },
  {
    path: "/ambulance-management/create-ambulance",
    element: <CreateOrEditAmbulance />,
  },
  {
    path: "/service-management",
    element: <ServiceManagement />,
  },
  {
    path: "/service-management/:id",
    element: <CreateOrEditService />,
  },
  {
    path: "/service-management/create-service",
    element: <CreateOrEditService />,
  },
  {
    path: "/route-logs",
    element: <RouteManagement />,
  },
  {
    path: "/route-logs/:id",
    element: <RouteDetails />,
  },
  {
    path: "/edit-profile",
    element: <UserEdit />,
  },
  {
    path: "/role-management",
    element: <RoleManagement />,
  },
  {
    path: "/role-management/details/:id",
    element: <RoleDetails />,
  },
  {
    path: "/role-management/:id",
    element: <CreateOrEditRole />,
  },
  {
    path: "/role-management/create-role",
    element: <CreateOrEditRole />,
  },
  {
    path: "/route-tracking/:id",
    element: <TrackingMap />,
  },
  {
    path: "/incident-logs",
    element: <IncidentManagement />,
  },
  {
    path: "/incident-logs/:id",
    element: <IncidentDetails />,
  },
  {
    path: "/map",
    element: <Map />,
  },
  {
    path: "/area-management",
    element: <AreaManagement />,
  },
  {
    path: "/area-management/:id",
    element: <CreateOrEditArea />,
  },
  {
    path: "/area-management/create-area",
    element: <CreateOrEditArea />,
  },
  {
    path: "/generate-report/ambulance",
    element: <AmbulanceReportManagement />,
  },
  {
    path: "/generate-report/user-request",
    element: <UserRequestReportManagement />,
  },
  {
    path: "/app-versioning-management",
    element: <AppVersioningManagement />,
  },
  {
    path: "/app-versioning-management/:id",
    element: <CreateOrEditAppVersion />,
  },
  {
    path: "/app-versioning-management/create-app-version",
    element: <CreateOrEditAppVersion />,
  },
  {
    path: "/advertising-management",
    element: <AdvertisingManagement />,
  },
  {
    path: "/advertising-management/:id",
    element: <CreateOrEditAdvertising />,
  },
  {
    path: "/advertising-management/create-advertising",
    element: <CreateOrEditAdvertising />,
  },
  ...userRequestRoutes,
  ...userRoutes,
];
